if (!customElements.get("accordion-item")) {
  class AccordionItem extends HTMLElement {
    constructor() {
      super();
    }

    updateHeight() {
      this.style.setProperty("--height-open", this.body.scrollHeight + "px");
    }

    connectedCallback() {
      this.opener = this.querySelector(".js-opener");
      this.body = this.querySelector(".js-body");

      if (!this.opener || !this.body) return;

      this.updateHeight();

      this.opener.addEventListener("click", (event) => {
        event.preventDefault();
        this.classList.toggle("is-open");
      });
    }
  }
  customElements.define("accordion-item", AccordionItem);
}
